import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from '../pages/home/home.component';
import { ContactUsComponent } from '../pages/contact-us/contact-us.component';
import { AboutComponent } from '../pages/about-us/about-us.component';
import { ProductsComponent } from '../pages/products/products.component';
import { BlogComponent } from '../pages/blog/blog.component';
import { PressComponent } from '../pages/press/press.component';
import { TitleToolboxComponent } from '../pages/products/title-toolbox/title-toolbox.component';
import { BlogArticleComponent } from '../pages/blog/blog-article/blog-article.component';
import { CareersComponent } from '../pages/careers/careers.component';
import { CareersDetailComponent } from '../pages/careers/careers-detail/careers-detail.component';
import { ReboGatewayComponent } from '../pages/products/rebo-gateway/rebo-gateway.component';
import {PremiereListComponent} from '../pages/products/premiere-list/premiere-list.component';
import { InvestorsTitleToolboxComponent } from '../pages/products/investors-title-toolbox/investors-title-toolbox.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'about-us', component: AboutComponent},
  { path: 'contact-us', component: ContactUsComponent},
  { path: 'products', component: ProductsComponent},
  { path: 'blog', component: BlogComponent},
  { path: 'press', component: PressComponent},
  { path: 'title-toolbox', component: TitleToolboxComponent},
  { path: 'rebo-gateway', component: ReboGatewayComponent},
  { path: 'premiere-list', component: PremiereListComponent},
  { path: 'investors-title-toolbox', component: InvestorsTitleToolboxComponent},
  { path: 'careers', component: CareersComponent},
  { path: ':careers-detail/:name', component: CareersDetailComponent},
  { path: 'blog-article', component: BlogArticleComponent},
  { path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class RoutingModule { }



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/routing/routing.module.ts